import React, { lazy, Suspense, useState } from "react";
import { Container, Row, Col, Image, Navbar } from "react-bootstrap";
import "./Combined.css";
import Highlights from "../Video Highlights/videoHighlighjts";
import Memories from "../Memory Highlights/memoryhighlights";
import htmlParser from 'html-react-parser';

export default function Combined({ carouselData,links , sunwestLink}) {

  return (
    <>

      <div className="combined-carousel">
        <div className="combined-heading">
          <div className="first-part pt-4 pb-4">Highlights From </div>
          <div className="second-part pt-4 pb-4">&nbsp;Prior Events</div>
        </div>
        <div className="carousel-section">
          <div className="highlights-section col-sm-12 col-xs-12 col-md-12 col-lg-6 col-xl-6">
            <Highlights />
          </div>
          <div className="memories-section col-sm-12 col-xs-12 col-md-12 col-lg-6 col-xl-6">
            <Memories />
          </div>
        </div>
                   
        <div className="bg6" />
      </div>
    </>
  );
}
